import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IVisaCategory } from "../visaCategoryModel";

export const getAllVisaCategories = createAsyncThunk(
  "VisaCategory/FindAllVisaCategory",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCategory/FindAllVisaCategory`,
        {
          VisaCategory: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching visa categories:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveVisaCategories = createAsyncThunk(
  "VisaCategory/FindAllActiveVisaCategory",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/VisaCategory/FindAllActiveVisaCategory`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching visa categories:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createVisaCategory = createAsyncThunk(
  "VisaCategory/InsertVisaCategory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCategory/InsertVisaCategory`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating visa category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateVisaCategory = createAsyncThunk(
  "VisaCategory/UpdateVisaCategory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCategory/UpdateVisaCategory`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating VisaCategory:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getVisaCategoryByID = createAsyncThunk(
  "VisaCategory/FindByIDVisaCategory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCategory/FindByIDVisaCategory`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        VisaCategory: result.VisaCategory,
        VisaCountryID: result.VisaCountryID,
        VisaCost: result.VisaCost,
        ProcessingTime: result.ProcessingTime,
        IsActive: result?.IsActive ? 1 : 2,
      } as IVisaCategory;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching VisaCategory:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const visaCategoryActiveInactive = createAsyncThunk(
  "VisaCategory/ActiveInActiveVisaCategory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCategory/ActiveInActiveVisaCategory`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive VisaCategory:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteVisaCategory = createAsyncThunk(
  "VisaCategory/DeleteVisaCategory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCategory/DeleteVisaCategory`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Visa Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
